
        let pvideos = document.querySelectorAll('.section-background_video video')
        pvideos.forEach(item=>{
            
                item.setAttribute('poster', '')
            })
      

 let ivideos = document.querySelectorAll('.section-background_video video img')
        ivideos.forEach(item=>{
            
                item.setAttribute('src', '')
            })
      

  